import React, { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import Reason from "../Reason/Reason";
import VerifyReason from "../VerifyReason/VerifyReason";

/* ---------- Types ---------- */

type StatusType = "A" | "I";

interface ReasonEvent {
  reason: string;
}

export interface ActiveInActivePayload {
  id: number | string;
  status: StatusType;
  reason: string;
}

interface ActiveInActiveProps {
  isOpen: boolean;
  toggle: () => void;
  status: StatusType;
  id: number | string;
  click: (payload: ActiveInActivePayload) => void;
  isloading?: boolean;
  ispasswordrequired?: boolean;
}

/* ---------- Component ---------- */

const ActiveInActive: React.FC<ActiveInActiveProps> = ({
  isOpen,
  toggle,
  status,
  id,
  click,
  isloading = false,
  ispasswordrequired = false,
}) => {
  /* ---------- Local State ---------- */

  const [isReasonModal, setIsReasonModal] = useState<boolean>(false);
  const [isVerifyModal, setIsVerifyModal] = useState<boolean>(false);

  /* ---------- Modal Toggles ---------- */

  const toggleReasonModal = (): void => {
    setIsReasonModal((prev) => !prev);
  };

  const toggleVerifyModal = (): void => {
    setIsVerifyModal((prev) => !prev);
  };

  /* ---------- Handlers ---------- */

  const btnReasonClick = (event: ReasonEvent): void => {
    const obj: ActiveInActivePayload = {
      id,
      status,
      reason: event.reason,
    };

    click(obj);

    // Close all modals cleanly
    setIsReasonModal(false);
    setIsVerifyModal(false);
    toggle();
  };

  /* ---------- Render ---------- */

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered
        modalClassName="zoomIn"
        backdrop="static"
      >
        <ModalBody className="p-4">
          <h5>{status === "A" ? "Activate" : "Deactivate"} Record</h5>
          <p className="fs-14 mb-4 mt-3">
            Are you sure you want to{" "}
            {status === "A" ? "Activate" : "Deactivate"} this record?
          </p>

          <div className="hstack gap-2 justify-content-end">
            <Button
              outline
              color="light"
              className="btn-sm fs-14"
              onClick={toggle}
            >
              Cancel
            </Button>

            <Button
              color="danger"
              className="btn-sm fs-14"
              onClick={() =>
                ispasswordrequired === false
                  ? toggleReasonModal()
                  : toggleVerifyModal()
              }
            >
              Yes, {status === "A" ? "Activate" : "Deactivate"} It
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* Reason Modal */}
      {isReasonModal && (
        <Reason
          isOpen={isReasonModal}
          toggle={toggleReasonModal}
          action={status === "A" ? "Activate" : "Deactivate"}
          click={btnReasonClick}
          isLoading={isloading}
        />
      )}

      {/* Verify Modal */}
      {isVerifyModal && (
        <VerifyReason
          isOpen={isVerifyModal}
          toggle={toggleVerifyModal}
          id={id}
          click={btnReasonClick}
          isRejectRequired={false}
          action={status === "A" ? "Activate" : "Deactivate"}
        />
      )}
    </>
  );
};

export default ActiveInActive;
